import { css } from 'linaria';

export const designProjectGallerySection = css`
  width: 100%;
  margin-bottom: 80px;

  @media (--to-desktop) {
    margin-bottom: 56px;
  }
`;

export const designProjectGalleryTitle = css`
  margin-bottom: 32px;

  @media (--only-mobile) {
    margin-bottom: 24px;
  }
`;

export const designProjectGallery = css``;

export const designProjectGallerySlide = css`
  && {
    position: relative;
    width: 372px;
    margin-right: 32px;
    border-radius: var(--rounding-m);

    @media (--to-desktop) {
      width: 292px;
    }

    @media (--only-mobile) {
      width: 218px;
      margin-right: 12px;
    }

    &:hover {
      p {
        background-color: var(--background-secondary);
      }
    }
  }
`;

export const designProjectGalleryImage = css`
  border-radius: var(--rounding-m);

  @media (--to-desktop) {
    width: 292px;
    height: 292px;
  }

  @media (--only-mobile) {
    width: 218px;
    height: 218px;
  }
`;

export const designProjectGalleryName = css`
  position: absolute;
  left: 16px;
  bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 340px;
  height: 74px;
  padding: 11px 32px;
  text-align: center;
  background: var(--background-primary);
  border-radius: var(--rounding-m);

  @media (--to-desktop) {
    bottom: 16px;
    width: 260px;
    height: 72px;
    padding: 12px 11px;
    font-size: 18px;
    line-height: 24px;
    border-radius: 2px;
  }

  @media (--only-mobile) {
    left: 12px;
    bottom: 14px;
    width: 194px;
    height: 54px;
    padding: 9px 12px;
    font-size: 14px;
    line-height: 20px;
  }
`;
